import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

const useStyles = makeStyles((theme) => ({
  card: {
    textAlign: "center",
    borderRadius: "5px",
    backgroundColor: theme.palette.events.grayShade2,
    border: "1px solid",
    borderColor: theme.palette.events.grayShade1,
    boxShadow: `4px 4px 4px 0px ${theme.palette.boxShadow.default}`,
    [theme.breakpoints.up("md")]: {
      textAlign: "left",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "top right",
      backgroundSize: "cover",
    },
  },
  title: {
    marginBottom: "5px",
  },
  subtitle: {
    color: `${theme.palette.text.primary} !important`,
  },
  cardInner: {
    [theme.breakpoints.down("md")]: {
      flexDirection: "column-reverse",
    },
  },
  buttonWrapper: {
    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
    },
  },
  button: {
    marginTop: "1rem",
  },
  animationContainer: {
    minHeight: "120px",
    [theme.breakpoints.up("sm")]: {
      width: "270px",
    },
  },
  animationSvg: {
    borderRadius: 5,
  },
}));

export default useStyles;
